import React, { useEffect } from 'react'
import gsap from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Header.scss';
import Navbar from '../../components/Navbar/Navbar';

gsap.registerPlugin(ScrollTrigger);

const Header = () => {
  useEffect(() => {
    const headerLine = document.querySelector('.header');
    const showAnim = gsap.from(headerLine, { 
      yPercent: -100,
      paused: true,
      duration: 0.2
    }).progress(1);
    
    ScrollTrigger.create({
      start: "top top",
      end: "max",
      onUpdate: (self) => {
        self.direction === -1 ? showAnim.play() : showAnim.reverse()
      }
    });
  });

  return (
    <header className="header">
      <div className="container">
        <Navbar />
      </div>
    </header>
  );
}

export default Header